import apiClient from '../client';
import type { StudentSession, CreateStudentSessionPayload, UpdateStudentSessionPayload } from '@/types';

const BASE = '/admin/student-sessions';

export const studentSessionsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: StudentSession[]; pagination: { total: number } }>(BASE, { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: StudentSession }>(`${BASE}/${id}`).then((r) => r.data.data),

  create: (payload: CreateStudentSessionPayload) =>
    apiClient.post<{ data: StudentSession }>(BASE, payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateStudentSessionPayload) =>
    apiClient.put<{ data: StudentSession }>(`${BASE}/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`${BASE}/${id}`),

  bulkEnroll: (payload: { student_ids: number[]; session_id: number; class_name: string; section?: string; branch_name: string }) =>
    apiClient.post<{ data: StudentSession[] }>(`${BASE}/bulk-enroll`, payload).then((r) => r.data.data),
};

